import React from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-content">
        <h1 className="hero-title">
          Fortifying digital space with<br />Value, Vision & Vigilance
        </h1>
        <p className="hero-subtitle">
          AI Vault is a next-generation IT solutions company with industry expertise, helping businesses drive AI innovation, digital transformation, and cyber-security resilience. With a security-first approach and strong global partnerships, we deliver future-ready IT ecosystems across applications, infrastructure, and cloud.
        </p>
        <div className="hero-buttons">
          <Link to="/contact" className="btn btn-primary">Get Started →</Link>
        </div>
      </div>

      <div className="rotating-ring ring-1"></div>
      <div className="rotating-ring ring-2"></div>
      <div className="rotating-ring ring-3"></div>
      <div className="rotating-ring ring-4"></div>
      

    </section>
  );
}

export default Hero;